'use client';

import { useBreakpoint } from '~/ui/components/grid/useBreakpoint';
import { Link } from '~/ui/components/link';
import { Breakpoint } from '~/ui/styles/grid';
import { Route } from '~/ui/systems/internalLink/route';

import styles from './mission-link.module.scss';

export function MissionLink() {
  const isSmallBreakpoint = useBreakpoint(Breakpoint.MOBILE);

  return (
    <Link
      href={Route.GRANT_MAKING_AREAS}
      className={styles.link}
      withIcon
      size={isSmallBreakpoint ? 'default' : 'large'}
    >
      View grantmaking areas
    </Link>
  );
}
